import Vue from 'vue'
import store from '@/store'
import Router from 'vue-router'
import iView from 'iview'
import routes from './routes'
import Cookies from 'js-cookie'
Vue.use(iView)
Vue.use(Router)

const router = new Router({
  mode: 'history',
  base : process.env.NODE_ENV === 'production'?'/customerui/' : '/',
  scrollBehavior: () => ({y: 0}),
  routes
})

router.beforeEach((to, from, next) => {
  if (document.documentElement.clientWidth <= 600) {
    store.commit('CLOSE_SLIDEBAR')
  }
  var uid = Cookies.get("uid");
  var token = Cookies.get("utn");
  if ( to.path == '/login') {
    if ( uid && token ) {
      next({path:'/'})
    }
    next();
  } else {
    if (to.meta.requiresAuth) {
      if ( uid && token ) {
        store.dispatch('getCurrentPageName', to.name)
        next()
      } else {
        next({
          path: '/login',
          query: {redirect: to.fullPath}
        })
      }
    } else {
      store.dispatch('getCurrentPageName', to.name)
      next()
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js